exports.onInitialClientRender = () => {
    if (typeof window !== 'undefined') {
        const el = document.querySelector(window.location.hash || null)
        if (el) {
            window.scrollTo(0, el.offsetTop - 20)
        }
    }
}
